// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q9oW","toggleWrap":"styles_toggleWrap__2fjEk","content":"styles_content__5zZ20","selectAreaCode":"styles_selectAreaCode__2EjbZ"};